import React, { useEffect, useState } from 'react';
import { ModalContainer, Spinner } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import {
	Container,
	Content,
	Footer,
	Title,
	Description,
	Wrapper,
} from './ExamsProfileModal.styles';
import { ReactComponent as Icon } from 'App/assets/img/heart.svg';
import { getAppointmentProfiles } from './services';
import { loggerInfo } from 'utils/infoLog';
import { Accordion } from './components/Accordion/Accordion';
import { useToast } from '@welbe/web-design-system';

export const ExamsProfileModal = ({
	mode,
	onClose,
}: {
	mode: 'view' | 'edit';
	onClose: () => void;
}) => {
	const isView = mode === 'view';
	const { toast } = useToast();
	const [profiles, setProfiles] = useState([]);
	const [isLoading, setLoading] = useState(false);

	const fetchProfiles = async () => {
		setLoading(true);
		try {
			const { data } = await getAppointmentProfiles();
			const profilesResponse = data?.content?.profiles;

			if (profilesResponse?.length) {
				setProfiles(profilesResponse);
			}
		} catch (error) {
			loggerInfo({
				data: error,
				context: 'candidate',
				location: 'fetchProfiles',
			});
			toast.error('Ocorreu um erro ao buscar os perfis de exames');
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchProfiles();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Wrapper>
			<ModalContainer
				visible
				width="620px"
				height="650px"
				id="exams-profile-modal"
				headerIcon={<Icon className="header-icon" />}
			>
				<Container>
					<div>
						<Title>Estudios médicos</Title>
						<Description>
							Consulta los estudios médicos correspondientes a cada perfil de
							puesto
						</Description>
					</div>
					<Content loading={isLoading}>
						{isLoading ? (
							<Spinner size="36px" />
						) : (
							<Accordion items={profiles} title="Perfiles" />
						)}
					</Content>
					<Footer justifyEnd={isView}>
						<Description>
							Para modificar o crear un perfil de puesto contacta con soporte
						</Description>
						{!isView && <Button>Continuar</Button>}
						<Button
							width="182px"
							variant={isView ? 'outline' : 'ghost'}
							onClick={onClose}
						>
							{isView ? 'Cerrar' : 'Cancelar'}
						</Button>
					</Footer>
				</Container>
			</ModalContainer>
		</Wrapper>
	);
};
